import React, { useState } from "react";
import Input from "../../components/ui/input";
import Button from "../../components/ui/button";
import styles from "./forgot-password.module.css";
import { useNavigate } from "react-router-dom";
import { showSuccessToast } from "../../utils/notifications";
import usePageTitle from "../../hooks/usePageTitle";

const ForgotPasswordPage = () => {
  usePageTitle('Recuperar Contraseña');
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = (e) => {
    e.preventDefault();
    showSuccessToast(`Se ha enviado un enlace de recuperación a: ${email}`);
  };

  return (
    <div className={styles.mainContainer}>
      <form onSubmit={handleForgotPassword} className={styles.formContainer}>
        <h1 className={styles.title}>Recuperar Contraseña</h1>

        <Input
          label="Correo Electrónico"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Correo electrónico"
          style={{ width: "100%" }}
        />
      
          <Button type="submit" style={{ width: "100%" }}>ENVIAR ENLACE</Button>
    
      </form>
    </div>
  );
};

export default ForgotPasswordPage;
